import { render, staticRenderFns } from "./c_slider.vue?vue&type=template&id=c3157ed4&scoped=true"
import script from "./c_slider.vue?vue&type=script&lang=js"
export * from "./c_slider.vue?vue&type=script&lang=js"
import style0 from "./c_slider.vue?vue&type=style&index=0&id=c3157ed4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3157ed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3157ed4')) {
      api.createRecord('c3157ed4', component.options)
    } else {
      api.reload('c3157ed4', component.options)
    }
    module.hot.accept("./c_slider.vue?vue&type=template&id=c3157ed4&scoped=true", function () {
      api.rerender('c3157ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_slider.vue"
export default component.exports